import DOMPurify from 'dompurify';
import { capMarkup } from './cap-markup';

export const MAX_PREVIEW_BYTES = 30_000;

export interface PreviewResult {
  markup: string;
  kind: 'html' | 'svg';
}

/**
 * Sanitize and cap an already-serialized HTML string.
 *
 * Consumers pass HTML serialized from the editor (e.g. Tiptap's
 * `editor.getHTML()`) — this function is DI-friendly so the editor dependency
 * stays at the call site, not here.
 */
export function buildDocumentPreviewHtml(html: string): PreviewResult {
  if (!html) return { markup: '', kind: 'html' };
  const sanitized = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });
  const capped = capMarkup(sanitized, MAX_PREVIEW_BYTES);
  return { markup: capped, kind: 'html' };
}
